import { SuccessResponseList } from './common'

export enum ActionType {
  program_change = 'Program Change',
  adam_change = 'ADaM Change',
  spec_change = 'Spec Change',
  clarification = 'Clarification',
}

export interface RequestUserMapping {
  default_action_types?: ActionType[]
  /** The ID from Teamwork (String/Int) */
  teamwork_user_id: string
  /** Display name for the UI */
  teamwork_username: string
  /** The internal Vista User ID to link */
  vista_user_id: string
}

export interface ResponseUserMapping {
  default_action_types: ActionType[]
  has_mapping: boolean
  mapping_id?: string | null
  teamwork_user_email?: string | null
  teamwork_user_id?: string | null
  teamwork_username?: string | null
  vista_avatar_url?: string | null
  vista_first_name?: string | null
  vista_last_name?: string | null
  vista_user_email?: string | null
  vista_user_id?: string | null
  vista_username?: string | null
}

export interface SuccessResponseResponseUserMapping extends SuccessResponseList<ResponseUserMapping> {}
